import { HelpCircle } from 'lucide-react';
import { Button, Dialog, DialogTrigger } from 'react-aria-components';
import { Popover } from '../tailgrids/core/popover.js';

/**
 * A (?) next to a label that opens the field's help. Keyboard reachable (Tab, Enter/Space), closes on
 * Escape or an outside click, and themed through the palette in light and dark.
 */
export function HelpIcon({ text, label = 'Help' }: { text: string; label?: string }) {
  return (
    <DialogTrigger>
      <Button
        // `slot={null}` opts out of a surrounding field's button slots (NumberField's increment / decrement), which
        // otherwise make this trigger throw "A slot prop is required".
        slot={null}
        aria-label={label}
        className="inline-flex size-5 items-center justify-center rounded-full text-faint outline-none transition-colors hover:text-accent-text focus-visible:ring-2 focus-visible:ring-accent/40"
      >
        <HelpCircle size={14} />
      </Button>
      {/* `bg-card-background`: the vendored popover paints `background-100` (#111827 in dark), not a NextAdmin surface. */}
      <Popover
        placement="bottom start"
        className="max-h-[60vh] max-w-sm overflow-auto bg-card-background p-4 shadow-lg"
      >
        <Dialog aria-label={label} className="whitespace-pre-wrap text-xs leading-relaxed text-body outline-none">
          {text}
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
}
